import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";

import arrowLeft from "../../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../../assets/img/components/arrow-right.webp";
import img1 from "../../../assets/img/landingPageFive/sectionTwo/pagar.png";
import img2 from "../../../assets/img/landingPageFive/sectionTwo/bonus.png";
import img3 from "../../../assets/img/landingPageFive/sectionTwo/saude.png";
import img4 from "../../../assets/img/landingPageFive/sectionTwo/treinamento.png";
import img5 from "../../../assets/img/landingPageFive/sectionTwo/uniforme.png";
import img6 from "../../../assets/img/landingPageFive/sectionTwo/desconto.png";
import img7 from "../../../assets/img/landingPageFive/sectionTwo/dente.png";
import img8 from "../../../assets/img/landingPageFive/sectionTwo/familia.png";
import arrow from "../../../../assets/img/components/buttonBlue.webp"

const CARDS = [
  { key: "lp5_why1", img: img1 },
  { key: "lp5_why2", img: img2 },
  { key: "lp5_why3", img: img3 },
  { key: "lp5_why4", img: img4 },
  { key: "lp5_why5", img: img5 },
  { key: "lp5_why6", img: img6 },
];

function SectionTwo() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  const breakpoints = {
    1300: {
      slidesPerView: 4,
    },
    1000: {
      spaceBetween: 20,
    },
    900: {
      slidesPerView: 3,
    },
    600: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1,
    },
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div id="services" className={`sectionTwo ${isVisible ? "visible" : ""}`}>
        <img className={`arrow1 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
        <img className={`arrow2 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
        <div className="sectionTwoTitle">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("lp5_why_title")}
          </h1>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("lp5_why_subtitle")}
          </p>
        </div>
        <Swiper
          slidesPerView={4}
          spaceBetween={40}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          speed={500}
          loop={true}
          modules={[Autoplay, Navigation]}
          breakpoints={breakpoints}
          className={`${isVisible ? "visible" : ""}`}
        >
          <div className={`swiper-button-prev`}>
            <img src={arrowLeft} width={"40px"} alt="" />
          </div>
          {CARDS.map((card) => (
            <SwiperSlide key={card.key}>
              <div className={`card1 card ${isVisible ? "visible" : ""}`}>
                <img src={card.img} alt="" />
                <p>{t(card.key)}</p>
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-next`}>
            <img src={arrowRight} width={"40px"} alt="" />
          </div>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}

export default SectionTwo;
